const DocumentiRegioneVentosaIcon =
  '../icone/icone-archivio-documenti/Regione Ventosa.svg';
const DocumentiIRCCSIcon = '../icone/icone-archivio-documenti/IRCCS.svg';
const DocumentiUOCIcon =
  '../icone/icone-archivio-documenti/UOC Pneumologia.svg';
const DocumentiOrganigrammaIcon =
  '../icone/icone-archivio-documenti/Organigramma.svg';
const DocumentiAnnoScorsoIcon =
  '../icone/icone-archivio-documenti/Dati Anno Scorso.svg';
const DocumentiAsmaIcon = '../icone/icone-archivio-documenti/LAsma.svg';
const DocumentiLetteraDGIcon =
  '../icone/icone-archivio-documenti/Lettera DG.svg';
const DocumentiReportIcon = '../icone/icone-archivio-documenti/Report.svg';
const DocumentiArticoloIcon =
  '../icone/icone-archivio-documenti/Articolo di Giornale.svg';
const DocumentiLetteraDS = '../icone/icone-archivio-documenti/Lettera DG.svg';

const TeacherSessionsIcon = '../icone/teacher/Sessioni.svg';
const TeacherSessionIcon = '../icone/teacher/Sessione.svg';
const TeacherMissionControlIcon = '../icone/teacher/mission-control-icon.svg';
const TeacherMissionControlWhiteIcon =
  '../icone/teacher/mission-control-icon-white.svg';
const TeacherDebriefWhiteIcon = '../icone/teacher/debrief-icon-white.svg';
const TeacherDebriefIcon = '../icone/teacher/debrief-icon.svg';
const TeacherDeleteIcon = '../icone/teacher/delete-icon.svg';
const TeacherBottomArrowIcon = '../icone/teacher/arrow-bottom.svg';
const TeacherTeachingNotesIcon = '../icone/teacher/Teaching-notes.svg';
const TeacherHelpIcon = '../icone/teacher/help-icon.svg';
const TeacherCopyLinkIcon = '../icone/teacher/teacher-copy-link-icon.svg';
const TeacherInfoIcon = '../icone/teacher/i.svg';
const TeacherStopIcon = '../icone/teacher/stop.svg';
const TeacherDownloadIcon = '../icone/teacher/download.svg';
const TeacherCSVIcon = '../icone/teacher/csv.svg';

const AvatarMale01 = '../avatar/Normal/Male/1.svg';
const AvatarMale02 = '../avatar/Normal/Male/2.svg';
const AvatarMale03 = '../avatar/Normal/Male/3.svg';
const AvatarMale04 = '../avatar/Normal/Male/4.svg';
const AvatarMale05 = '../avatar/Normal/Male/5.svg';
const AvatarMale06 = '../avatar/Normal/Male/6.svg';
const AvatarFemale01 = '../avatar/Normal/Female/1.svg';
const AvatarFemale02 = '../avatar/Normal/Female/2.svg';
const AvatarFemale03 = '../avatar/Normal/Female/3.svg';
const AvatarFemale04 = '../avatar/Normal/Female/4.svg';
const AvatarFemale05 = '../avatar/Normal/Female/5.svg';
const AvatarFemale06 = '../avatar/Normal/Female/6.svg';

const Phase01Icon = '../icone/start/Fase 1.svg';
const Phase02Icon = '../icone/start/Fase 2.svg';
const Phase03Icon = '../icone/start/Fase 3.svg';

const images = (s: string) => `${process.env.ASSETS_URL}/images/${s}`;
const documents = (s: string) => `${process.env.ASSETS_URL}/documents/${s}`;

const AvatarDirettoreSanitario = images(
  'icon-ruolo/Big/Direttore Sanitario.svg'
);
const AvatarClinicoReferenteFederAsma = images(
  'icon-ruolo/Big/Clinico Referente FederAsma.svg'
);
const AvatarDirettoreDipartimentoMedicinaInterna = images(
  'icon-ruolo/Big/Direttore Dipartimento Medicina Interna.svg'
);
const AvatarDirettoreFarmaciaOspedaliera = images(
  'icon-ruolo/Big/Direttore Farmacia Ospedaliera.svg'
);
const AvatarDirettoreUOCPneumologia = images(
  'icon-ruolo/Big/Direttore UOC Pneumologia.svg'
);
const AvatarProvveditoreEconomo = images(
  'icon-ruolo/Big/Provveditore Economo.svg'
);

const AvatarDirettoreSanitarioSmallNotRead = images(
  'icon-ruolo/Piccola/Non Letta/Direttore Sanitario.svg'
);
const AvatarClinicoReferenteFederAsmaSmallNotRead = images(
  'icon-ruolo/Piccola/Non Letta/Clinico Referente FederAsma.svg'
);
const AvatarDirettoreDipartimentoMedicinaInternaSmallNotRead = images(
  'icon-ruolo/Piccola/Non Letta/Direttore Dipartimento Medicina Interna.svg'
);
const AvatarDirettoreFarmaciaOspedalieraSmallNotRead = images(
  'icon-ruolo/Piccola/Non Letta/Direttore Farmacia Ospedaliera.svg'
);
const AvatarDirettoreUOCPneumologiaSmallNotRead = images(
  'icon-ruolo/Piccola/Non Letta/Direttore UOC Pneumologia.svg'
);
const AvatarProvveditoreEconomoSmallNotRead = images(
  'icon-ruolo/Piccola/Non Letta/Provveditore Economo.svg'
);

const AvatarDirettoreSanitarioSmallRead = images(
  'icon-ruolo/Piccola/Letta/Direttore Sanitario.svg'
);
const AvatarClinicoReferenteFederAsmaSmallRead = images(
  'icon-ruolo/Piccola/Letta/Clinico Referente FederAsma.svg'
);
const AvatarDirettoreDipartimentoMedicinaInternaSmallRead = images(
  'icon-ruolo/Piccola/Letta/Direttore Dipartimento Medicina Interna.svg'
);
const AvatarDirettoreFarmaciaOspedalieraSmallRead = images(
  'icon-ruolo/Piccola/Letta/Direttore Farmacia Ospedaliera.svg'
);
const AvatarDirettoreUOCPneumologiaSmallRead = images(
  'icon-ruolo/Piccola/Letta/Direttore UOC Pneumologia.svg'
);
const AvatarProvveditoreEconomoSmallRead = images(
  'icon-ruolo/Piccola/Letta/Provveditore Economo.svg'
);

const AvatarDirettoreSanitarioSmallPersonal = images(
  'icon-ruolo/Piccola/Personal/Direttore Sanitario.svg'
);
const AvatarClinicoReferenteFederAsmaSmallPersonal = images(
  'icon-ruolo/Piccola/Personal/Clinico Referente FederAsma.svg'
);
const AvatarDirettoreDipartimentoMedicinaInternaSmallPersonal = images(
  'icon-ruolo/Piccola/Personal/Direttore Dipartimento Medicina Interna.svg'
);
const AvatarDirettoreFarmaciaOspedalieraSmallPersonal = images(
  'icon-ruolo/Piccola/Personal/Direttore Farmacia Ospedaliera.svg'
);
const AvatarDirettoreUOCPneumologiaSmallPersonal = images(
  'icon-ruolo/Piccola/Personal/Direttore UOC Pneumologia.svg'
);
const AvatarProvveditoreEconomoSmallPersonal = images(
  'icon-ruolo/Piccola/Personal/Provveditore Economo.svg'
);

export default {
  /** logos */
  'logos.sda-bocconi.image.url': images('logo_sda.png'),
  'logos.llab-ext.image.url': images('logo_llab_ext.png'),
  'logos.llab-ext-tablet.image.url': images('logo_llab_ext_tablet.png'),
  'logos.hospitalia-logo.image.url': images('hospitalia_logo_white.png'),
  'logos.llab-area-white.image.url': images('llab_area_white.png'),
  'logos.llab-area.image.url': images('llab_area.png'),

  /** pages */
  'home:welcome.label': 'Benvenuto',
  'home:faculty-authors.title': 'Faculty Authors:',
  'home:faculty-authors.name.1': 'Patrizio Armeni',
  'home:faculty-authors.name.2': 'Arianna Bertolani',
  'home:faculty-authors.name.3': 'Francesco Costa',
  'home:faculty-authors.name.4': 'Monica Otto',
  'home:faculty-authors.area': 'Government, Health and Not for Profit',

  'pages:rules.title': 'Le icone nel tuo menu',
  'pages:intro-mandate.title': 'Il tuo mandato',
  'pages:intro-team.title': 'Il tuo team',

  'pages:mandate.title': 'Mandato',
  'pages:mandate.content':
    '<p>Sei un professionista dell’<em>IRCCS Fondazione S. Gennaro Del Buon Respiro</em>, ospedale generale della <em>regione Ventosa</em> riconosciuto come eccellenza a livello nazionale per la qualità della produzione scientifica e dell’assistenza erogata.</p><p>Assieme ad altri professionisti, sarai chiamato a prendere alcune <b>decisioni</b> importanti per la struttura sanitaria presso la quale presti servizio.</p><p>Ricorda che anche «una non scelta è una scelta» e per questo motivo, se non prenderai nessuna decisione nel <b>tempo a disposizione</b>, il sistema inserirà casualmente una <b>risposta di default</b>.</p><p>Buon lavoro!</p>',

  'pages:documents.title': 'Archivio Documenti',

  'pages:avatar-selection.title': 'Tu sei il...',
  'pages:avatar-selection.content': 'Scegli il tuo Avatar',

  'pages:my-profile-presentation.title': 'Descrizione',
  'pages:my-profile-goals.title': 'I tuoi obiettivi',

  'pages:waiting-rooms.background.url': images('waiting-room/bg.png'),
  'pages:waiting-rooms-avatar.title':
    'Attendi che ciascun membro del tuo Team abbia scelto il suo Avatar',
  'pages:waiting-rooms-avatar.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-intro.title':
    'Un attimo di pazienza... resta in attesa, a breve il Docente attiverà la prossima fase',
  'pages:waiting-rooms-intro.message':
    'Il tempo a tua disposizione inizierà a scorrere da quel momento',
  'pages:waiting-rooms-phase-1.title':
    'Un attimo di pazienza... resta in attesa, a breve il Docente attiverà la prossima fase',
  'pages:waiting-rooms-phase-1.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-phase-2.title':
    'Un attimo di pazienza... resta in attesa, a breve il Docente attiverà la prossima fase',
  'pages:waiting-rooms-phase-2.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-phase-3.title':
    'Un attimo di pazienza... resta in attesa, a breve il Docente attiverà la prossima fase',
  'pages:waiting-rooms-phase-3.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-votation-1.title':
    'Attendi che ciascun membro del tuo Team abbia dato la sua risposta',
  'pages:waiting-rooms-votation-1.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-votation-2.title':
    'Attendi che ciascun membro del tuo Team abbia dato la sua risposta',
  'pages:waiting-rooms-votation-2.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-satisfaction-3.title':
    'Attendi che ciascun membro del tuo Team abbia dato la sua risposta',
  'pages:waiting-rooms-satisfaction-3.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:waiting-rooms-ds-vote.title':
    'Attendi che il Direttore Sanitario risponda',
  'pages:waiting-rooms-ds-vote.message':
    'Utilizza il tempo che hai a disposizione per consultare i documenti',
  'pages:my-team-members.title': 'Il tuo team',
  'pages:my-team-goals.title': 'Gli obiettivi del tuo team',
  'pages:profiles.title': 'Il tuo team',

  'pages:survey.title-1':
    'Quanto sei soddisfatto della scelta fatta dal tuo team?',
  'pages:survey.title-2':
    'Quanto ti senti rappresentato dalla scelta fatta dal tuo team?',

  'pages:outcomes-phase-1.message':
    'Il tuo team ha deciso di applicare per il prossimo anno una variazione del budget sulla spesa dei farmaci per il trattamento dell’asma grave pari a',
  'pages:outcomes-phase-1.notes':
    '(il risultato è stato calcolato come la media dei voti del team)',

  'pages:phases-phase-1.icon.alt': '',
  'pages:phases-phase-1.icon.url': Phase01Icon,
  'pages:phases-phase-1.title': '1. Definizione delle risorse',
  'pages:phases-phase-1.intro.content':
    'Come riportato nella lettera inviata dal Direttore Generale, il primo step per poter raggiungere gli obiettivi assegnati alla vostra struttura dalla Regione, consiste nella definizione delle risorse da assegnare al trattamento dell’asma grave per il prossimo anno.',
  'pages:phases-phase-1.waiting.message':
    'Attendi che il docente attivi la prossima fase.',

  'pages:phases-phase-2.icon.alt': '',
  'pages:phases-phase-2.icon.url': Phase02Icon,
  'pages:phases-phase-2.title':
    '2. Allocazione delle risorse e scelte terapeutiche',
  'pages:phases-phase-2.intro.title':
    '2. Allocazione delle risorse e scelte terapeutiche',
  'pages:phases-phase-2.intro.content':
    'Il Direttore Generale vi chiede in questa fase di allocare le risorse assegnate dal vostro team al trattamento dell’asma grave per il prossimo anno tra le terapie ad oggi disponibili.',

  'pages:phases-phase-3.icon.alt': '',
  'pages:phases-phase-3.icon.url': Phase03Icon,
  'pages:phases-phase-3.title': '3. Gestione Evento Straordinario',
  'pages:phases-conclusions.title': '3. Gestione Evento Straordinario',
  'pages:phases-phase-3.intro.title': '3. Gestione Evento Straordinario',
  'pages:phases-phase-3.intro.content':
    'Durante questa fase sarete chiamati a prendere alcune decisioni di carattere organizzativo in seguito al verificarsi di un evento straordinario. ',

  'pages:scenarios-phase-1.title': '1. Definizione delle risorse',
  'pages:scenarios-phase-1.content':
    'Alla luce del tuo mandato e della performance aziendale dello scorso anno relativa al trattamento dell’asma grave riassunta in calce:',

  'pages:scenarios-phase-2.title':
    '2. ALLOCAZIONE DELLE RISORSE E SCELTE TERAPEUTICHE',
  'pages:scenarios-phase-2.content':
    'Hai appena ricevuto il resoconto relativo alle scelte che il team di cui fai parte ha preso in merito alle risorse da allocare al trattamento dell’asma grave che riportiamo nella tabella di seguito:',
  'pages:scenarios-phase-2.table.h1': 'Anno precedente',
  'pages:scenarios-phase-2.table.h2': 'Variazione',
  'pages:scenarios-phase-2.table.h3': 'Anno prossimo',

  // 'pages:select-answer.message': 'Seleziona la tua risposta:',
  // 'pages:decisions-phase-1.content':
  //   '<p>In attesa che si attivi la chat room per confrontarti con il team, utilizza il tempo che hai a disposizione per consultare i documenti</p>',
  'pages:decisions-phase-1.message':
    '(il risultato sarà calcolato come media aritmetica delle votazioni fatte)',

  'decisions:phase-1.option:DecreaseBudgetFor1M': '- 1.000.000 €',
  'decisions:phase-1.option:DontChangeBudget': '0 €',
  'decisions:phase-1.option:IncreaseBudgetFor500K': '+ 500.000 €',
  'decisions:phase-1.option:DecreaseBudgetFor1MAnd500K': '- 1.500.000 €',
  'decisions:phase-1.option:DecreaseBudgetFor500K': '- 500.000 €',
  'decisions:phase-1.option:IncreaseBudgetFor1MAnd500K': '+ 1.500.000 €',
  'decisions:phase-1.option:DecreaseBudgetFor100K': '- 100.000 €',
  'decisions:phase-1.option:IncreaseBudgetFor3M': '+ 3.000.000 €',
  'decisions:phase-1.option:IncreaseBudgetFor1M': '+ 1.000.000 €',

  'pages:decisions-phase-2.title':
    'Considerato che avete votato per una variazione di budget di {budgetAmountResult} €, come penseresti di fare variare o rimodulare l’adozione di farmaci biologici per il prossimo anno in funzione della variazione decisa dal tuo team?',
  'pages:decisions-phase-2.subtitle':
    "Ad esempio aumento/diminuzione di uno dei biologici, spostamento del budget su uno dei due biologici. Prima di prendere una decisione ti consigliamo di rileggere “l’Asma: contenuti e definizione” nell'archivio documenti.",
  'pages:decisions-phase-2.content':
    '<p>In attesa che si attivi la chat room per confrontarti con il team, utilizza il tempo che hai a disposizione per consultare i documenti</p>',
  'pages:decisions-phase-2.message':
    '(il risultato sarà deciso dalla maggioranza delle votazioni fatte)',
  'decisions:phase-2.option:1': 'Aumento di entrambi i farmaci biologici',
  'decisions:phase-2.option:2': 'Aumento dell’utilizzo di Broncolumab',
  'decisions:phase-2.option:3': 'Aumento dell’utilizzo di Polmolumab',
  'decisions:phase-2.teamDecision': 'Il tuo team ha deciso',
  'decisions:phase-2.tableDescription':
    'di conseguenza gli impatti sono riportati nella seguente tabella:',

  'decisions:phase-2.option:DismissICS':
    'Utilizzo di soli farmaci biologici (senza trattare pazienti con altre tipologie di farmaci, come i corticosteroidi per via inalatoria - ICS)',
  'decisions:phase-2.option:IncreaseOMABudget':
    'Aumento dell’utilizzo di Broncolumab',
  'decisions:phase-2.option:DecreaseOMABudget':
    'Riduzione dell’utilizzo di Broncolumab',
  'decisions:phase-2.option:IncreaseMEPOBudget':
    'Aumento dell’utilizzo di Polmolumab',
  'decisions:phase-2.option:DecreaseMEPOBudget':
    'Riduzione dell’utilizzo di Polmolumab',
  'decisions:phase-2.option:DoNothing': 'Nessuna modifica',
  'decisions:phase-2.option:MoveBudgetFromOMAtoMEPO':
    'Riduzione dell’utilizzo di Broncolumab; aumento dell’utilizzo di Polmolumab',
  'decisions:phase-2.option:MoveBudgetFromMEPOtoOMA':
    'Riduzione dell’utilizzo di Polmolumab; aumento dell’utilizzo di Broncolumab',
  'decisions:phase-2.option:IncreaseOMAandMEPOBudget':
    'Aumento di entrambi i farmaci biologici',

  'pages:decisions-phase-3.title':
    'Il report regionale che avete ricevuto ha individuato i seguenti punti di attenzione:',
  'pages:decisions-phase-3.content':
    'In attesa che si attivi la chat room per confrontarti con il team, utilizza il tempo che hai a disposizione per consultare i documenti',

  'pages:decisions-motivation.title': 'MOTIVA LA TUA RISPOSTA:',
  'pages:decisions.motivation': 'Motivazione:',

  'pages:decisions-phase-3.statement':
    'Quali delle seguenti scelte vorresti perseguire?',
  'pages:decisions-phase-3.message':
    '(Il risultato sarà deciso esclusivamente dal Direttore Sanitario)',
  'pages:decisions.waitForSatisfactionVote':
    'Tra qualche istante ti verrà chiesto di esprimere una valutazione in merito alla tua soddisfazione',
  'pages:decisions-phase-3.number-0': 'a.',
  'pages:decisions-phase-3.number-1': 'b.',

  'pages:decisions-diagnosis.subtitle': ' ',
  'pages:decisions-diagnosis.title':
    'Sulla base dell’assemblea straordinaria che hai avuto con i membri del team, quali delle seguenti scelte vorresti perseguire?',
  'pages:decisions-diagnosis.message':
    '(Il risultato sarà deciso esclusivamente dal Direttore Sanitario)',
  'pages:decisions-diagnosis.number': '1.',
  'pages:decisions-diagnosis.statement':
    'Diagnosi e presa in carico del paziente affetto da asma grave',
  'pages:decisions-diagnosis.answer-ImproveWelfareContinuity':
    'Investire sul miglioramento della continuità assistenziale tra ospedale e territorio',
  'pages:decisions-diagnosis.answer-InvestOnPeopleSensitization':
    'Investire in attività di sensibilizzazione della popolazione sui temi dell’asma grave',

  'pages:decisions-distribution.title':
    'Sulla base dell’assemblea straordinaria che hai avuto con i membri del team, quali delle seguenti scelte vorresti perseguire?',
  'pages:decisions-distribution.subtitle': ' ',
  'pages:decisions-distribution.message':
    '(Il risultato sarà deciso esclusivamente dal Direttore Sanitario)',
  'pages:decisions-distribution.number': '2.',
  'pages:decisions-distribution.statement':
    'Costi correlati alla distribuzione diretta (DD)',
  'pages:decisions-distribution.answer-IncreaseDPCUtilization':
    'Puntare su un maggiore utilizzo della DPC',
  'pages:decisions-distribution.answer-ImproveWarehouseManagement':
    'Investire in opere di riorganizzazione del magazzino e delle sue funzioni',

  'pages:decisions-tender.title':
    'Sulla base dell’assemblea straordinaria che hai avuto con i membri del team, quali delle seguenti scelte vorresti perseguire?',
  'pages:decisions-tender.subtitle': ' ',
  'pages:decisions-tender.message':
    '(Il risultato sarà deciso esclusivamente dal Direttore Sanitario)',
  'pages:decisions-tender.number': '3.',
  'pages:decisions-tender.statement': 'Costi per i ricorsi e le gare deserte',
  'pages:decisions-tender.answer-ImproveSuppliersCompetition':
    'Individuare modalità volte ad aumentare il livello di competizione tra le imprese fornitrici',
  'pages:decisions-tender.answer-CentralizePurchasing':
    'Spingere verso un maggior grado di centralizzazione degli acquisti',

  'pages:meetings.questionTitle': 'La domanda a cui dovrai rispondere:',
  'pages:meetings.roomLink': 'Unisciti alla riunione',

  'pages:meetings-first-leg.background.url': images('meetings/meeting_1.png'),
  'pages:meetings-first-meeting.title': 'In Partenza',
  'pages:meetings-first-meeting.content':
    'La prima riunione del Comitato Strategico dell’IRCCS S. Gennaro del Buon Respiro è andata per le lunghe e la decisione in merito alla definizione delle risorse da assegnare alle terapie per l’asma grave è stata rimandata al prossimo incontro. Questo ti permetterà di fare questa scelta con maggiore consapevolezza, in quanto avrai la possibilità di confrontarti con i maggiori esperti in materia al prossimo convegno organizzato da ',
  'pages:meetings-first-meeting.questionStatement':
    'Di quanto faresti variare le risorse a disposizione dell’asma grave per il prossimo anno?',
  'pages:meetings-first-meeting.notes':
    'Considera che dovrai scegliere fra tre opzioni incluse in una forbice da -1,5Ml a +3Ml.',

  'pages:meetings-second-meeting.background.url': images(
    'meetings/meeting_2.png'
  ),
  'pages:meetings-second-meeting.title': 'In Partenza',
  'pages:meetings-second-meeting.content':
    'La seconda riunione del Comitato Strategico dell’IRCCS S. Gennaro del Buon Respiro è stata interrotta da un blackout che ha bloccato l’attività dell’intera azienda sanitaria e, quindi, non siete riusciti a prendere una decisione finale. Questo ti permetterà ancora una volta di fare la scelta con maggiore consapevolezza, in quanto avrai la possibilità di confrontarti con i maggiori esperti in materia al prossimo convegno organizzato da ',
  'pages:meetings-second-meeting.questionStatement':
    'Considerato che avete votato per una variazione di budget di {budgetAmountResult} €, come penseresti di fare variare o rimodulare l’adozione di farmaci biologici per il prossimo anno?',
  'pages:meetings-second-meeting.notes': ' ',

  'pages:meetings-DirettoreSanitario.sign': 'GASP',
  'pages:meetings-DirettoreSanitario.sign.ext':
    '(Gruppo Aziende Sanitarie Pubbliche)',
  'pages:meetings-DirettoreFarmaciaOspedaliera.sign': 'FIFO',
  'pages:meetings-DirettoreFarmaciaOspedaliera.sign.ext':
    '(Federazione italiana farmacisti ospedalieri)',
  'pages:meetings-DirettoreDipartimentoMedicinaInterna.sign': 'LUPO',
  'pages:meetings-DirettoreDipartimentoMedicinaInterna.sign.ext':
    '(Lavori Uniti Pneumologi Ospedalieri)',
  'pages:meetings-DirettoreUOCPneumologia.sign': 'I-LASThMA',
  'pages:meetings-DirettoreUOCPneumologia.sign.ext':
    '(International Lab for Asthma)',
  'pages:meetings-ProvveditoreEconomo.sign': 'DIRE',
  'pages:meetings-ProvveditoreEconomo.sign.ext':
    '(Direzione Italiana per la Razionalizzazione Economica)',
  'pages:meetings-ClinicoReferenteFederAsma.sign': 'FantAsma',
  'pages:meetings-ClinicoReferenteFederAsma.sign.ext':
    '(Convegno associazione pazienti pediatrici)',

  'pages:beaking-news.title': 'BREAKING NEWS!',
  'pages:beaking-news.content':
    'È arrivato il report regionale, è su tutte le principali testate giornalistiche',
  'pages:beaking-news.image.url': images('breaking-news.png'),
  'pages:beaking-news.image.alt': ' ',

  'pages:my-goals.team.title': 'OBIETTIVI DEL TEAM',
  'pages:my-goals.personal.title': 'I TUOI OBIETTIVI',

  'pages:feedbacks-YouAreOpen.title': "YOU'RE OPEN",
  'pages:feedbacks-YouAreOpen.message':
    'Il tuo Team dimostra apertura verso il coinvolgimento strutturato degli stakeholder esterni all’azienda, sui quali l’azienda non ha diretto potere gestionale e decisionale',
  'pages:feedbacks-YouAreOpen.img.url': 'feedbacks/feedback_1.png',
  'pages:feedbacks-YouAreOpen.img.alt': 'feedback_1',
  'pages:feedbacks-MeMyselfAndI.title': 'ME, MYSELF AND I',
  'pages:feedbacks-MeMyselfAndI.message':
    "Il tuo team ha deciso di focalizzare l'attenzione sulla revisione delle procedure interne aziendali e di attivare iniziative sulle quali ha un diretto potere gestionale e decisionale",
  'pages:feedbacks-MeMyselfAndI.img.url': 'feedbacks/feedback_2.png',
  'pages:feedbacks-MeMyselfAndI.img.alt': 'feedback_2',

  'pages:outcomes.title': 'La decisione del tuo team',
  'pages:outcomes.phase-3.title': 'Cosa ha deciso il Direttore Sanitario',

  'pages:thankyou.title': 'Grazie per aver partecipato!',
  'pages:thankyou.img.url': 'thankyou.png',
  'pages:thankyou.img.alt': 'Grazie!',

  'pages:conversation-report.missing-messages':
    'Nessun messaggio inviato in questa fase.',
  'pages:conversation-report.background.url': images('hospital-and-people.png'),
  'pages:conversation-report.outcomes-phase-1.title':
    'Il team ha deciso di applicare per il prossimo anno una variazione del budget sulla spesa dei farmaci per il trattamento dell’asma grave pari a...',
  'pages:conversation-report.outcomes-phase-2.title':
    'La decisione del team su come variare o rimodulare l’adozione di farmaci biologici per il prossimo anno è stata...',
  'pages:conversation-report.outcomes-phase-3.title':
    'Il Direttore Sanitario ha preso le seguenti decisioni...',

  'icon:right-arrow.img.url': images('right-arrow.png'),
  'icon:save.img.url': images('save.svg'),
  'icon:check': images('check.png'),
  'icon:cross': images('cross.png'),

  /** navigation */
  'navigation:start.label': 'Inizia',
  'navigation:next.label': 'Avanti',
  'navigation:confirm.label': 'Conferma',
  'navigation:vote.label': 'Vota',
  'navigation:documents.message': 'È arrivato un nuovo documento',
  'navigation:chat.message': 'È aperta la chat',
  'navigation:chat.disabled.message': 'La chat è chiusa',
  'navigation:timer-popup.message':
    'Attenzione: il tempo a tua disposizione inizierà a scorrere al tuo click sul bottone <b>"AVANTI"</b>',
  'navigation:documents.show-button.label': 'Mostra',
  'navigation:documents.hide-button.label': 'Nascondi',
  'navigation:timer.title': 'Tempo rimanente',
  'navigation:processingMessage.label': 'Attendi...',

  /** rules */
  'rules:documents.title': 'Archivio Documenti',
  'rules:documents.content':
    'Clicca su questa icona per consultare in qualsiasi momento i documenti ricevuti: è il tuo archivio.',

  'rules:timer.title': 'Tempo Rimanente',
  'rules:timer.content':
    'Per ognuna delle fasi simulate, avrai a disposizione un tempo entro cui effettuare tutte le azioni richieste. Il tempo residuo a tua disposizione sarà sempre visibile in cima alla barra del menu.',

  'rules:your-team.title': 'Il tuo Team',
  'rules:your-team.content':
    'Durante la sessione farai parte di un team di professionisti con specifici background. Clicca su questa icona per conoscere il profilo degli altri membri del team: conoscerai ruoli e caratteristiche.',

  'rules:your-goals.title': 'I tuoi Obiettivi',
  'rules:your-goals.content':
    'Clicca su questa icona per accedere in qualsiasi momento agli obiettivi che ti sono stati assegnati.',

  'rules:chat.title': 'Chat',
  'rules:chat.content':
    'Quando questa icona è attiva potrai accedere ad un area di chat, utile per confrontarti con gli altri membri del team sui temi che ti saranno sottoposti.',

  'rules:back-to-story.title': 'Torna alla Storia',
  'rules:back-to-story.content':
    'Nel corso della sessione sei libero di spostarti tra le varie sezioni di gioco. Clicca sulla bussola per ritornare in qualsiasi momento alla sezione corrente o alla prossima cosa da fare (in base alla fase di gioco in cui ti trovi).',

  /** profiles */
  'profiles:DirettoreSanitario.icon.url': AvatarDirettoreSanitario,
  'profiles:DirettoreSanitario.icon.not-read.small.url':
    AvatarDirettoreSanitarioSmallNotRead,
  'profiles:DirettoreSanitario.icon.read.small.url':
    AvatarDirettoreSanitarioSmallRead,
  'profiles:DirettoreSanitario.icon.personal.small.url':
    AvatarDirettoreSanitarioSmallPersonal,
  'profiles:DirettoreSanitario.name': 'Dr. Tramontana',
  'profiles:DirettoreSanitario.title': 'Direttore Sanitario',
  'profiles:DirettoreSanitario.long-description':
    '<p>La direzione sanitaria non era tra i tuoi progetti di vita, ma hai dovuto accettarla <em>tuo malgrado</em>. Dieci mesi fa, infatti, ti ha chiamato il direttore generale Giuliano Cesari chiedendoti con forza di sostituire in questo ruolo il dott. Placido La Palude che andava in pensione, a suo dire decisamente troppo «morbido» e mancante di leadership, anche se molto amato dai clinici e dai farmacisti. </p><p>Ti ritieni una persona <b>decisa e chiara ma anche portata alla mediazione e all’ascolto</b>: purtroppo, dopo i primi mesi in questo ruolo hai il sospetto che gli altri ti percepiscano solo sotto una dimensione autoritaria e tirannica. Infatti, il tuo predecessore aveva sempre lasciato alle altre figure aziendali (clinici, farmacisti ecc.) la libertà di prendere le decisioni più importanti in autonomia, il che secondo il DG ha solo generato un clima di conflitto, una spesa farmaceutica fuori controllo e una sensazione diffusa di anarchia. E se c’è una cosa che detesti, è proprio l’anarchia…tutte quelle <em>primedonne…</em>e ti tocca anche farli sentire importanti. </p><p>Non volevi la direzione sanitaria, ma dato che non hai avuto scelta, vuoi portarla avanti fino in fondo, e se gli altri prima facevano come volevano, <b>ora la musica è cambiata</b>. Credi profondamente, infatti, che con una guida forte e sicura sia <b>possibile coniugare l’eccellenza clinica (incluse le terapie innovative) e una gestione oculata delle spese. </b>Fosse per te, conflitti, inefficienza e anarchia sparirebbero con <b>regole ferree e con una concentrazione decisionale più forte nelle tue mani.</b> Basta con l’accettazione di tutte le novità in campo farmaceutico (bisogna valutarle…e chi meglio di te può farlo?), basta con la letterale perdita di tempo costituita dai PDTA, e soprattutto basta con le discussioni in cui tutti devono per forza ritenere di essere i soli ad aver diritto a decidere. </p><p>Se si è un team bisogna collaborare e ascoltarsi, ma sei tu, il DS, a dover dare la vera impronta decisionale. </p><p>Del resto gli obiettivi che ti ha dato il DG sono una vera sfida: i) <b>porre un freno alla crescita della spesa</b> per farmaci, ma senza creare barriere per l’innovazione, ii) <b>aumentare la reputazione clinica dell’azienda</b> migliorando gli esiti e l’appropriatezza (in particolare, devi ridurre il ricorso inappropriato al pronto soccorso e ai ricoveri) e iii) <b>diminuire la percezione di conflittualità</b>, migliorando il clima organizzativo (e sarà sua cura misurare questo aspetto). </p><p>Sono una vera sfida, una sfida che tu vuoi vincere. Anzi, una sfida che tu vincerai!</p>',
  'profiles:DirettoreSanitario.short-description':
    '<p>Meno di un anno fa ha sostituito il buon Dott. La Palude, comprensivo e che lasciava libertà: è andato in pensione e la persona che lo ha sostituito è <b>autoritaria, poco incline al dialogo e molto attenta alla spesa</b>. </p><p>Il suo carattere è spesso spigoloso e non ama molto le innovazioni gestionali: c’è il vago sospetto che <b>preferirebbe decidere autonomamente e senza ascoltare nessuno</b>. A parole, però, fa continuo riferimento al team, all’ascoltarsi a vicenda, alla forza del «gruppo» sopra gli individui e all’importanza di arrivare <em>insieme</em> a decisioni <em>condivise</em>. Questa apparente incongruenza rende questa figura sempre in <b>costante oscillazione tra estrema tirannia e caloroso team-building.</b></p>',
  'profiles:DirettoreSanitario.shortname': 'DS',

  'profiles:DirettoreFarmaciaOspedaliera.icon.url':
    AvatarDirettoreFarmaciaOspedaliera,
  'profiles:DirettoreFarmaciaOspedaliera.icon.not-read.small.url':
    AvatarDirettoreFarmaciaOspedalieraSmallNotRead,
  'profiles:DirettoreFarmaciaOspedaliera.icon.read.small.url':
    AvatarDirettoreFarmaciaOspedalieraSmallRead,
  'profiles:DirettoreFarmaciaOspedaliera.icon.personal.small.url':
    AvatarDirettoreFarmaciaOspedalieraSmallPersonal,
  'profiles:DirettoreFarmaciaOspedaliera.name': 'Dr. Matraccio',
  'profiles:DirettoreFarmaciaOspedaliera.title':
    'Direttore Farmacia Ospedaliera',
  'profiles:DirettoreFarmaciaOspedaliera.long-description':
    '<p>Da 15 anni dirigi la struttura complessa Farmacia ospedaliera dell’IRCCS S. Gennaro Del Buon Respiro. Sei ormai un’istituzione dell’azienda: conosci tutti e tutti ti conoscono. L’IRCCS S. Gennaro Del Buon Respiro è la tua vera casa. </p><p>Presiedi all’organizzazione del lavoro di 6 farmacisti collaboratori, 2 farmacisti borsisti e 12 operatori con ruolo tecnico-amministrativo. Il tuo team è veramente fantastico e tutto l’ospedale dovrebbe funzionare come la tua farmacia. <b>Lavorare in team ti piace</b>, trovi <b>appagante organizzare il lavoro altrui</b> e, certo delle tue doti manageriali, sei <b>molto esigente nelle aspettative</b>, consapevole che la farmacia ospedaliera è un po’ come una brigata di cucina dove è categorico lavorare tutti con ordine e precisione. Ma fai anche molta attenzione al clima e alla soddisfazione di quelli che chiami «i tuoi ragazzi», che infatti <b>ti adorano</b>.</p><p>Probabilmente è grazie alla tua <b>affidabilità e puntualità </b>che il DG ti ha scelto come presidente della commissione tecnica aziendale deputata alla valutazione delle tecnologie sanitarie (farmaci e DM) da introdurre in azienda. Al di fuori della farmacia, <b>ritieni di avere la reputazione di una persona carismatica e determinata, di quelle con cui è meglio essere d’accordo</b>: tutti ricordano ancora le tue battaglie per dare alla farmacia un ruolo centrale nella determinazione dei budget farmaceutici dei dipartimenti e per l’istituzione di riunioni mensili per analizzare i tuoi report sui flussi di spesa. Inoltre, sia il DG sia il nuovo DS hanno manifestato grande apprezzamento per queste iniziative, nonché per il <b>supporto all’attività di procurement e ti coinvolgono sempre di più nei tavoli decisionali aziendali</b>: evidentemente hanno capito che senza il tuo supporto il contenimento delle spese resterà sempre un’utopia. </p><p>Hai recentemente avviato un programma finalizzato ad una <b>corretta gestione del farmaco da parte del paziente</b>. Da anni, infatti, avvalori la tesi che un miglioramento dell’aderenza terapeutica e della compliance delle terapie possa portare ad un incremento dei livelli di salute e una riduzione dei costi associati alla gestione di complicanze o esacerbazioni della condizione patologica. L’attività di ricerca è sempre stata <b>una tua passione sin dai tempi degli studi</b>, infatti oltre alla specializzazione in farmacia ospedaliera hai recentemente conseguito un dottorato di ricerca in farmacologia clinica che ti ha portato ad <b>incrementare il numero di pubblicazioni scientifiche anche attraverso studi real world condotti in azienda</b>. Però, di recente, Dall’Aria (responsabile UOC Pneumologia) ha cercato di centralizzare su di sé la leadership di questi studi, e non sembra felice di coinvolgerti (e certo, sei quello che vede come «il tagliatore di terapie»).</p>',
  'profiles:DirettoreFarmaciaOspedaliera.short-description':
    '<p>Lavora da lunga data in azienda e tutti hanno imparato a conoscerne e a prevedere le «manie». Sarà per la passione per la chimica e per le scienze esatte che ha alimentato i suoi studi sin dai tempi dell’università, ma <b>ha fatto della precisione lo scopo della sua vita</b>. Ogni mese convoca tutti per analizzare i report di spesa e consumi…una noia infinita a discutere di virgole (peggio di un amministratore di condominio, e forse meno interessante). Questa caratteristica, a volte maniacale, gli è costata il soprannome «Dr. Precisetti» coniato da quei colleghi che negli anni hanno lavorato con  e «per» il dr Matraccio. Coloro che hanno lavorato nel suo gruppo (i «suoi ragazzi» come li chiama lui), infatti, hanno sempre raccontato aneddoti leggendari sulla sua mania dell’ordine, sia in laboratorio sia nella gestione dei conti.</p><p>La sua attenzione ai costi però è stata <b>molto apprezzata dal management aziendale</b> che spesso ha utilizzato il suo costante interesse nella razionalizzazione della spesa per farmaci e DM come ariete da sfondamento durante la negoziazione del budget con i diversi clinici che hanno, di conseguenza, <b>cominciato a maturare sentimenti ostili nei suoi confronti</b>. Sarà noioso, ma tutti lo rispettano, lo temono e non osano inimicarselo in modo troppo evidente.</p>',
  'profiles:DirettoreFarmaciaOspedaliera.shortname': 'DF',

  'profiles:DirettoreDipartimentoMedicinaInterna.icon.url':
    AvatarDirettoreDipartimentoMedicinaInterna,
  'profiles:DirettoreDipartimentoMedicinaInterna.icon.not-read.small.url':
    AvatarDirettoreDipartimentoMedicinaInternaSmallNotRead,
  'profiles:DirettoreDipartimentoMedicinaInterna.icon.read.small.url':
    AvatarDirettoreDipartimentoMedicinaInternaSmallRead,
  'profiles:DirettoreDipartimentoMedicinaInterna.icon.personal.small.url':
    AvatarDirettoreDipartimentoMedicinaInternaSmallPersonal,
  'profiles:DirettoreDipartimentoMedicinaInterna.name': 'Dr. Sofa',
  'profiles:DirettoreDipartimentoMedicinaInterna.title':
    'Direttore Dipartimento Medicina Interna',
  'profiles:DirettoreDipartimentoMedicinaInterna.long-description':
    "<p>Sono pochi i medici che danno lustro al proprio ospedale: tu sei uno di quelli. Laurea in Medicina e Chirurgia con specializzazione in Cardiologia e in Malattie dell'Apparato Respiratorio, allievo dello storico dott. Franco Ansimante, sei responsabile del Centro di Riferimento Regionale Fibrosi Cistica e membro di diversi gruppi di studio per la stesura delle raccomandazioni internazionali sulle sigarette elettroniche e per il trattamento della fibrosi cistica e della tubercolosi. <b>Una somma di cariche che solo i veri «guru» possono vantare</b>. </p><p>Se in Italia si parla di malattie respiratorie, tu sei il primo ad essere invitato. All’interno dell’IRCCS S. Gennaro Del Buon Respiro sei il direttore del Dipartimento di Medicina Interna da 10 anni e da un anno sei Direttore ad interim della Unità Operativa Complessa (UOC) di Cardiologia, incarico che ti ha permesso di trovare molte sinergie tra le due UOC, tanto da chiedere –e ottenere- la tua permanenza come direttore di entrambe. La tua carriera si è sviluppata all’interno dell’ospedale cercando di combinare le tue due specializzazioni, motivo per cui ti sei focalizzato sul trattamento della fibrosi cistica e delle complicazioni correlate.</p><p>Non hai mai dimenticato la tua <b>passione per la formazione</b>, arrivando a ricoprire il ruolo di professore ordinario di Malattie Respiratorie ed entrando a far parte del Consiglio di Amministrazione dell'Università degli Studi di Ventosa. Ti piace molto anche essere chiamato in tv a discutere di temi di medicina e hai uno specializzando sempre dedicato a gestire (a tuo nome) i tuoi profili sui social network per sfatare i falsi miti e le bufale sulle malattie respiratorie. È da sottolineare anche il tuo<b> impegno politico, che ti ha portato per 4 anni ad essere eletto parlamentare</b> e, tutt’oggi, mantieni <b>ottime relazioni con i referenti politici, il ministero e le commissioni parlamentari impegnate nella tutela della salute.</b></p><p>Purtroppo, se la società civile, la politica e i referenti italiani della medicina riconoscono appieno il tuo valore, all’interno dell’ospedale c’è qualcuno che, secondo te «rema contro». Non sai se ce l’hanno con te per invidia o per presunta superiorità, ma hai l’impressione che <b>alcuni vogliano ostinatamente peggiorare le performance di alcune UOC del tuo dipartimento per crearti problemi </b>(non è un mistero che tu ambisca alla direzione sanitaria o, chissà, anche qualcosa in più…). Ad esempio, da qualche tempo, la numerosità di ricoveri per asma grave è in netto aumento, così come la spesa complessiva correlata (sia per i farmaci che per l’ospedalizzazione in generale). La tua speranza è di essere l’<b>interlocutore diretto ed unico delle direzioni generale e sanitaria </b>al momento della negoziazione di budget e obiettivi, potendoli così imporre ai direttori delle UOC del tuo dipartimento…come dici sempre tu «se non puoi convincerli, comandali».</p>",
  'profiles:DirettoreDipartimentoMedicinaInterna.short-description':
    '<p><b>Individualista e autoreferenziale</b>, non in grado di fare squadra e non incline a condividere obiettivi. La sua carriera, così come il suo atteggiamento, dimostrano quanto sia <b>attento ai riconoscimenti personali</b>, arrivando a collezionare responsabilità e titoli su più fronti (clinico e universitario soprattutto) e non creando occasioni di confronto con colleghi. Molto <b>ben introdotto politicamente</b> (è stato parlamentare 4 anni) e sempre presente in qualche talk show televisivo, è anche molto attivo su internet per sfatare miti e bufale sulla medicina (diciamo che in questo si fa «aiutare» da qualche suo studente). Non supporta concretamente il networking inter e intra- disciplinare (se non per visibilità personale) e non è certo un fan del governo clinico esteso (a meno che non sia lui il nodo centrale della rete). </p><p>Non dimostra particolare interesse per la raccolta e lo studio di evidenze real world, né per la ricerca in genere, nonostante sia professore universitario e abbia uno stuolo di fedelissimi specializzandi. Da quando è arrivato Tramontana come nuovo DS, <b>la sua performance come direttore di dipartimento e di UOC è sotto la lente di ingrandimento</b>…così come la sua carriera…</p>',
  'profiles:DirettoreDipartimentoMedicinaInterna.shortname': 'DM',

  'profiles:DirettoreUOCPneumologia.icon.url': AvatarDirettoreUOCPneumologia,
  'profiles:DirettoreUOCPneumologia.icon.not-read.small.url':
    AvatarDirettoreUOCPneumologiaSmallNotRead,
  'profiles:DirettoreUOCPneumologia.icon.read.small.url':
    AvatarDirettoreUOCPneumologiaSmallRead,
  'profiles:DirettoreUOCPneumologia.icon.personal.small.url':
    AvatarDirettoreUOCPneumologiaSmallPersonal,
  'profiles:DirettoreUOCPneumologia.name': "Dr. Dell'Aria",
  'profiles:DirettoreUOCPneumologia.title': 'Direttore UOC Pneumologia',
  'profiles:DirettoreUOCPneumologia.long-description':
    '<p>Dopo una breve e folgorante carriera, maturata grazie esclusivamente ai tuoi precocissimi meriti scientifici, dirigi da due anni l’unità operativa complessa (UOC) di Pneuomologia dell’IRCCS S. Gennaro Del Buon Respiro della Regione Ventosa. Fai parte del gruppo SANI (Severe Asthma Network Italy) e, a livello internazionale hai dato un fondamentale contributo al GINA (Global initiative for asthma). </p><p>Sei consapevole di essere un persona che ha fatto <b>carriera solo grazie ai suoi meriti,</b> e questa cosa ti riempie di orgoglio. Infatti, hai ottenuto una specializzazione in Pneumologia presso la prestigiosa Columbia University, con una tesi pioneristica sulla generazione di evidenze real world nell’ambito dell’asma grave, poi pubblicata sul New England Journal of Medicine. Dal tuo rientro in Italia (10 anni fa) hai lavorato presso diverse strutture ospedaliere, riuscendo ad integrare nel migliore dei modi la<b> ricerca scientifica con l’introduzione dei nuovi farmaci nella pratica clinica</b>. Da 5 anni hai iniziato a lavorare presso l’IRCCS S. Gennaro Del Buon Respiro dove, grazie al tuo forte profilo di ricerca e alla capacità di attirare investimenti da parte delle aziende farmaceutiche, hai creato all’interno della UOC di Pneumologia il Centro di Medicina Personalizzata sulle Malattie Infiammatorie Polmonari. Inoltre, sei professore associato di Pneuomologia all’Università. </p><p>La (relativamente) giovane età ti fa spesso essere <b>oggetto di pregiudizi</b> (non te lo dicono in faccia, ma sai benissimo che diverse persone ritengono la tua posizione frutto di chissà quali macchinazioni e raccomandazioni). È una cosa che ti manda su tutte le furie: pensi siano tutti invidiosi e, quando parli con i tuoi collaboratori, definisci questi squallidi personaggi «dei poveracci». Tra questi rientra certamente il direttore del dipartimento di Medicina Interna, a cui afferisce la UOC di Pneumologia, esempio paradigmatico di attaccamento alla poltrona. </p><p>Anche il Direttore Sanitario è tra i «poveracci»…avete avuto più di un litigio, non capisce che tu sei <b>l’unica persona in grado di fare scelte sensate nel tuo campo</b>, e questa ossessione del risparmio, della centralizzazione delle decisioni e della verifica proprio non la sopporti. Ad esempio, da anni stai cercando di sviluppare un PDTA sull’asma grave a livello regionale, sulla scia della virtuosa regione Ventosa confinante (benchmark individuato dal Ministro della Salute), ma la direzione sanitaria continua a liquidare questa iniziativa come una «perdita di tempo». Non è da meno la direzione della farmacia, la cariatide dell’ospedale, che ha usato i suoi dati per prendersi un dottorato in farmacologia e ora pretende di saper fare studi real word, quando poi non è in grado di distinguere un farmaco nuovo da uno vecchio (e sa chiedere solo di risparmiare)… </p>',
  'profiles:DirettoreUOCPneumologia.short-description':
    '<p>Direttore dell’unità operativa complessa di Pneuomologia dell’IRCCS S. Gennaro Del Buon Respiro della Regione Ventosa. Rampante, abbastanza giovane, dal ricchissimo pedigree (specializzato negli USA, molte pubblicazioni, parla quasi più Inglese che Italiano). </p><p>In molti lo considerano come una <b>persona saccente e troppo incentrata sulla discussione dei massimi sistemi in ambito scientifico</b>, perdendo il contatto con la corrente pratica clinica. Sembra quasi dispiaciuto quando deve allontanarsi dalla scrittura di un paper scientifico per andare a visitare i pazienti. </p><p>La sua rapida carriera all’interno dell’IRCCS S. Gennaro Del Buon Respiro ed i suoi continui inviti a partecipare a congressi internazionali hanno suscitato l’<b>invidia di molti colleghi</b>, che non sostengono i suoi progetti, come lo sviluppo di PDTA. È molto ricercato dai network scientifici e ha molti contatti con il mondo delle imprese farmaceutiche, ma <b>non ama molto la politica e le sue logiche</b>.</p>',
  'profiles:DirettoreUOCPneumologia.shortname': 'DP',

  'profiles:ProvveditoreEconomo.icon.url': AvatarProvveditoreEconomo,
  'profiles:ProvveditoreEconomo.icon.not-read.small.url':
    AvatarProvveditoreEconomoSmallNotRead,
  'profiles:ProvveditoreEconomo.icon.read.small.url':
    AvatarProvveditoreEconomoSmallRead,
  'profiles:ProvveditoreEconomo.icon.personal.small.url':
    AvatarProvveditoreEconomoSmallPersonal,
  'profiles:ProvveditoreEconomo.name': 'Dr. Hardy-Scount',
  'profiles:ProvveditoreEconomo.title': 'Provveditore Economo',
  'profiles:ProvveditoreEconomo.long-description':
    '<p>Di lontane origini nobili inglesi, da quando hai assunto la responsabilità della funzione acquisti dell’IRCCS S. Gennaro Del Buon Respiro, hai capito che gli economi/provveditori sono figure altamente bistrattate e sottovalutate nelle aziende ospedaliere pubbliche. <b>Tutti pensano che il tuo lavoro sia quello di un semplice «passacarte»</b>, che deve solo scrivere un bando di gara sulle informazioni ricevute da chi «conta davvero». Eh, «solo scrivere un bando»…non hanno capito, invece, che la persona responsabile del procurement è <b>colui o colei che davvero traduce in pratica la volontà di acquisto e la disponibilità a pagare dell’azienda</b>. </p><p>È il procurement a generare concorrenza tra i fornitori o a velocizzare l’approvvigionamento di farmaci e dispositivi medici. È sempre il procurement a intervenire quando si generano emergenze nelle forniture, sempre più frequenti. Quindi, farebbero tutti meglio a considerare maggiormente il tuo ruolo. Peraltro, le tue origini familiari sono sicuramente legate al fatto che <b>non ti piace sentirti «ai margini» e, anzi, sei molto attratto dall’idea di incidere maggiormente nelle decisioni importanti. </b>Dopo un lento lavorio «ai fianchi» dell’organizzazione, ormai siedi in tutte le commissioni decisionali che riguardano le tecnologie e il tuo telefono squilla molto più spesso di prima. </p><p>Dal punto di vista istituzionale, sei stato da poco nominato <b>referente regionale alla Direzione Italiana per la Razionalizzazione Economica (D.I.R.E.),</b> che raggruppa molti dei tuoi pari e attraverso la quale stai promuovendo progetti volti a massimizzare i risparmi degli ospedali: un progetto da te promosso, denominato «Procu-save» ha riguardato la riduzione dei prezzi aggiudicati in gara attraverso l’estensione del concetto di equivalenza terapeutica, ma ha ricevuto una brusca frenata da parte dell’AIFA a causa del mancato riconoscimento scientifico della traduzione operativa del concetto di equivalenza. All’interno dell’IRCCS S. Gennaro Del Buon Respiro stai sempre più sensibilizzando i tuoi interlocutori, clinici e non, sulla necessità di produrre più risparmio in ambito farmaceutico e manifestando spesso scetticismo nei confronti di terapie «cosiddette» innovative, che secondo te non aggiungono quasi nulla e quindi non dovrebbero essere preferite a farmaci magari più vecchi, ma sicuramente funzionanti e molto più economici. Queste posizioni <b>ti attirano feroci critiche soprattutto da parte della UOC Pneumologia</b>, dove la direzione ha una marcata affinità con le case farmaceutiche e si batte perché nell’azienda siano acquistati anche i farmaci più costosi. In generale, <b>hai l’impressione che tutti ti considerino una persona aggressiva, ignorante e senza scrupoli</b>. La farmacia, invece, pur non riconoscendoti una reale voce in capitolo, sembra concordare con l’idea di risparmiare soldi e, in alcuni frangenti, potrebbe essere un buon alleato nell’adozione di misure volte a ridurre la spesa per farmaci, che del resto è un obiettivo specifico assegnatoti dal DG in persona.</p>',
  'profiles:ProvveditoreEconomo.short-description':
    '<p>Responsabile del procurement. Tutti dicono che dovrebbe occuparsi solo di garantire che i farmaci arrivino in tempo in azienda e di scrivere i bandi di gara, ma questa persona di lontane origini nobili inglesi sembra <b>determinata a far credere di essere il vero attore pivotale dell’azienda</b>. Ha dei modi tendenzialmente aggressivi e adotta un atteggiamento di superiorità. </p><p><b>Il suo pallino è il risparmio ad ogni costo</b> e le procedure di acquisto che avvia vanno spesso deserte. A volte si ha l’impressione che sia proprio il suo operato a generare criticità nella disponibilità delle terapie e dell’allungamento conseguente delle liste d’attesa. <b>Recentemente il suo potere interno è aumentato</b> e, nel panorama istituzionale, è diventato referente regionale della Direzione Italiana per la Razionalizzazione Economica (D.I.R.E.)</p>',
  'profiles:ProvveditoreEconomo.shortname': 'PE',

  'profiles:ClinicoReferenteFederAsma.icon.url':
    AvatarClinicoReferenteFederAsma,
  'profiles:ClinicoReferenteFederAsma.icon.not-read.small.url':
    AvatarClinicoReferenteFederAsmaSmallNotRead,
  'profiles:ClinicoReferenteFederAsma.icon.read.small.url':
    AvatarClinicoReferenteFederAsmaSmallRead,
  'profiles:ClinicoReferenteFederAsma.icon.personal.small.url':
    AvatarClinicoReferenteFederAsmaSmallPersonal,
  'profiles:ClinicoReferenteFederAsma.name': 'Dr. Ventolini',
  'profiles:ClinicoReferenteFederAsma.title': 'Clinico Referente FederAsma',
  'profiles:ClinicoReferenteFederAsma.long-description':
    '<p>«Perché una persona dovrebbe fare il medico se non per il bene dei pazienti?» </p><p>Da anni hai appeso un cartello con questa scritta dietro la tua scrivania ingombra di cartelle cliniche e strumenti per visitare i pazienti. Ti occupi di malattie respiratorie e, in particolare, segui assiduamente i casi di asma grave. Nel tuo ufficio, vicino a un vecchio divano dall’aria vissuta, hai un grande cestino di vimini pieno di giocattoli, perché i tuoi pazienti sono di tutte le età e curare i bambini per te è più di una priorità: è una missione. Per le tue visite con ci sono orari, <b>hai sempre tempo per tutti i tuoi pazienti. </b></p><p>Da anni, in estate impieghi il tuo monte ferie per andare a prestare servizio volontario lì dove c’è più bisogno. Le pareti del tuo ufficio, infatti, sono piene di foto che ti ritraggono sorridente insieme a bambini di ogni parte del mondo. La vita organizzativa, però, è molto meno entusiasmante dell’impegno per aiutare le persone malate. Infatti, <b>hai spesso l’impressione che alle persone che lavorano nell’IRCCS S. Gennaro Del Buon Respiro non importi granché della salute dei pazienti </b>e che, anzi, siano tutti concentrati sul raggiungimento di obiettivi personali. Tra i tuoi colleghi clinici, il direttore della UOC Pneumologia, a cui tu afferisci, manifesta interesse soprattutto per la ricerca e lascia volentieri le visite ai giovani specializzandi o ai colleghi; il direttore del dipartimento, ex-politico, mette più impegno nel farsi vedere in tv che nel pensare davvero ai pazienti (poi non capisce molto di asma grave). Il direttore sanitario, di fresca nomina, ha in testa l’efficienza ma è l’unica persona che sembra interessata a parlare di teamworking… non parliamo della farmacia e del procurement che di recente fanno una cosa pericolosissima: parlano di risparmiare soldi sulle spalle dei pazienti, togliendo risorse alla spesa farmaceutica. </p><p>Ma non le vedono loro le persone che aspettano settimane prima di avere una visita? Non sanno cosa vuol dire per una persona convivere con l’asma grave senza poter accedere a terapie efficaci? Questi non hanno idea che, per un paziente, il controllo dei sintomi dell’asma grave è un beneficio incommensurabile, non solo per l’aspetto clinico ma anche per la qualità della vita. Pensate all’ansia di una mamma il cui bimbo improvvisamente ha una crisi respiratoria… quanto vale per quella mamma acquisire la tranquillità che suo figlio respiri senza problemi?… questi lo lascerebbero con l’asma grave per risparmiare quattro soldi… che poi potrebbero risparmiarli semplicemente facendo come me, che ho in ufficio il vecchio divano di mia zia e non mi faccio comprare la scrivania di mogano e le poltroncine in pelle… </p><p>Sui pazienti non si risparmia! È per questo che ogni anno, ostinatamente <b>ti batti strenuamente per far aumentare il budget farmaceutico e per far ridurre di conseguenza i tempi di attesa</b>. Queste tue convinzioni hanno portato l’associazione di pazienti FederAsma a nominarti referente clinico.</p>',
  'profiles:ClinicoReferenteFederAsma.short-description':
    '<p>Clinico di riferimento per l’asma grave, ha una particolare predisposizione al trattamento anche in età pediatrica. </p><p>È la classica persona che<b> interpreta la professione medica come una missione sacra</b>, alla quale sacrifica la sua intera esistenza. Non si conoscono legami sentimentali nella sua vita: ha sposato il suo lavoro e i suoi figli sono gli innumerevoli bambini che cura per volontariato durante le sue ferie estive. </p><p>È molto difficile interagire con questa persona, pare abbia un chiodo fisso: qualunque argomento si sollevi, <b>se ne esce costantemente con la richiesta di più soldi, </b>perché i pazienti vengono prima, perché le liste di attesa sono lunghe, ecc. Nessuno può davvero dire di averne un’opinione negativa, ma la sua conversazione monotematica alla lunga ha generato un <b>diffuso senso di disinteresse e di sufficienza nei suoi confronti. </b>C’è solo un aspetto che rende questa persona potenzialmente problematica: presta servizio (volontario, si capisce) presso l’associazione di pazienti FederAsma, e le sue opinioni si riflettono costantemente nel consenso delle persone malate e di chi sta loro intorno… e il consenso conta…</p>',
  'profiles:ClinicoReferenteFederAsma.shortname': 'CA',

  /** documents */
  'documents:RegioneVentosa.title': 'La Regione Ventosa',
  'documents:RegioneVentosa.image.url': DocumentiRegioneVentosaIcon,
  'documents:RegioneVentosa.image.alt': '',
  'documents:RegioneVentosa.attachment.url': documents('regione-ventosa.jpg'),

  'documents:IRCCS.title': 'La Fondazione',
  'documents:IRCCS.image.url': DocumentiIRCCSIcon,
  'documents:IRCCS.image.alt': '',
  'documents:IRCCS.attachment.url': documents('irccs.jpg'),

  'documents:UOCPneumologia.title': 'UOC Pneumologia',
  'documents:UOCPneumologia.image.url': DocumentiUOCIcon,
  'documents:UOCPneumologia.image.alt': '',
  'documents:UOCPneumologia.attachment.url': documents('uoc-pneumologia.jpg'),

  'documents:Organigramma.title': 'IRCCS - Organigramma',
  'documents:Organigramma.image.url': DocumentiOrganigrammaIcon,
  'documents:Organigramma.image.alt': '',
  'documents:Organigramma.attachment.url': documents('organigramma.jpg'),

  'documents:AnnoScorso.title': 'Dati rilevati anno precedente',
  'documents:AnnoScorso.image.url': DocumentiAnnoScorsoIcon,
  'documents:AnnoScorso.image.alt': '',
  'documents:AnnoScorso.attachment.url': documents('anno-scorso.jpg'),

  'documents:AsmaGrave.title': "L'Asma: contesto e definizioni",
  'documents:AsmaGrave.image.url': DocumentiAsmaIcon,
  'documents:AsmaGrave.image.alt': '',
  'documents:AsmaGrave.attachment.url': documents('asma-grave.jpg'),

  'documents:LetteraDG.title': 'Lettera del Direttore Generale',
  'documents:LetteraDG.image.url': DocumentiLetteraDGIcon,
  'documents:LetteraDG.image.alt': '',
  'documents:LetteraDG.attachment.url': documents('lettera-dg.jpg'),

  'documents:Report.title': 'Report regionale',
  'documents:Report.image.url': DocumentiReportIcon,
  'documents:Report.image.alt': '',
  'documents:Report.attachment.url': documents('report.jpg'),

  'documents:Articolo.title': 'Articolo di Prima Pagina',
  'documents:Articolo.image.url': DocumentiArticoloIcon,
  'documents:Articolo.image.alt': '',
  'documents:Articolo.attachment.url': documents('articolo.jpg'),

  'documents:LetteraDS.title': 'Lettera del Direttore Sanitario',
  'documents:LetteraDS.image.url': DocumentiLetteraDS,
  'documents:LetteraDS.image.alt': '',
  'documents:LetteraDS.attachment.url': documents('lettera-ds.jpg'),

  /** avatars */
  'avatars:avatar-0.url': AvatarMale01,
  'avatars:avatar-1.url': AvatarMale02,
  'avatars:avatar-2.url': AvatarMale03,
  'avatars:avatar-3.url': AvatarMale04,
  'avatars:avatar-4.url': AvatarMale05,
  'avatars:avatar-5.url': AvatarMale06,
  'avatars:avatar-6.url': AvatarFemale01,
  'avatars:avatar-7.url': AvatarFemale02,
  'avatars:avatar-8.url': AvatarFemale03,
  'avatars:avatar-9.url': AvatarFemale04,
  'avatars:avatar-10.url': AvatarFemale05,
  'avatars:avatar-11.url': AvatarFemale06,

  'avatars:DirettoreSanitario-0.url': AvatarMale01,
  'avatars:DirettoreSanitario-1.url': AvatarMale02,
  'avatars:DirettoreSanitario-2.url': AvatarMale03,
  'avatars:DirettoreSanitario-3.url': AvatarMale04,
  'avatars:DirettoreSanitario-4.url': AvatarMale05,
  'avatars:DirettoreSanitario-5.url': AvatarMale06,
  'avatars:DirettoreSanitario-6.url': AvatarFemale01,
  'avatars:DirettoreSanitario-7.url': AvatarFemale02,
  'avatars:DirettoreSanitario-8.url': AvatarFemale03,
  'avatars:DirettoreSanitario-9.url': AvatarFemale04,
  'avatars:DirettoreSanitario-10.url': AvatarFemale05,
  'avatars:DirettoreSanitario-11.url': AvatarFemale06,

  'avatars:DirettoreFarmaciaOspedaliera-0.url': AvatarMale01,
  'avatars:DirettoreFarmaciaOspedaliera-1.url': AvatarMale02,
  'avatars:DirettoreFarmaciaOspedaliera-2.url': AvatarMale03,
  'avatars:DirettoreFarmaciaOspedaliera-3.url': AvatarMale04,
  'avatars:DirettoreFarmaciaOspedaliera-4.url': AvatarMale05,
  'avatars:DirettoreFarmaciaOspedaliera-5.url': AvatarMale06,
  'avatars:DirettoreFarmaciaOspedaliera-6.url': AvatarFemale01,
  'avatars:DirettoreFarmaciaOspedaliera-7.url': AvatarFemale02,
  'avatars:DirettoreFarmaciaOspedaliera-8.url': AvatarFemale03,
  'avatars:DirettoreFarmaciaOspedaliera-9.url': AvatarFemale04,
  'avatars:DirettoreFarmaciaOspedaliera-10.url': AvatarFemale05,
  'avatars:DirettoreFarmaciaOspedaliera-11.url': AvatarFemale06,

  'avatars:DirettoreDipartimentoMedicinaInterna-0.url': AvatarMale01,
  'avatars:DirettoreDipartimentoMedicinaInterna-1.url': AvatarMale02,
  'avatars:DirettoreDipartimentoMedicinaInterna-2.url': AvatarMale03,
  'avatars:DirettoreDipartimentoMedicinaInterna-3.url': AvatarMale04,
  'avatars:DirettoreDipartimentoMedicinaInterna-4.url': AvatarMale05,
  'avatars:DirettoreDipartimentoMedicinaInterna-5.url': AvatarMale06,
  'avatars:DirettoreDipartimentoMedicinaInterna-6.url': AvatarFemale01,
  'avatars:DirettoreDipartimentoMedicinaInterna-7.url': AvatarFemale02,
  'avatars:DirettoreDipartimentoMedicinaInterna-8.url': AvatarFemale03,
  'avatars:DirettoreDipartimentoMedicinaInterna-9.url': AvatarFemale04,
  'avatars:DirettoreDipartimentoMedicinaInterna-10.url': AvatarFemale05,
  'avatars:DirettoreDipartimentoMedicinaInterna-11.url': AvatarFemale06,

  'avatars:DirettoreUOCPneumologia-0.url': AvatarMale01,
  'avatars:DirettoreUOCPneumologia-1.url': AvatarMale02,
  'avatars:DirettoreUOCPneumologia-2.url': AvatarMale03,
  'avatars:DirettoreUOCPneumologia-3.url': AvatarMale04,
  'avatars:DirettoreUOCPneumologia-4.url': AvatarMale05,
  'avatars:DirettoreUOCPneumologia-5.url': AvatarMale06,
  'avatars:DirettoreUOCPneumologia-6.url': AvatarFemale01,
  'avatars:DirettoreUOCPneumologia-7.url': AvatarFemale02,
  'avatars:DirettoreUOCPneumologia-8.url': AvatarFemale03,
  'avatars:DirettoreUOCPneumologia-9.url': AvatarFemale04,
  'avatars:DirettoreUOCPneumologia-10.url': AvatarFemale05,
  'avatars:DirettoreUOCPneumologia-11.url': AvatarFemale06,

  'avatars:ProvveditoreEconomo-0.url': AvatarMale01,
  'avatars:ProvveditoreEconomo-1.url': AvatarMale02,
  'avatars:ProvveditoreEconomo-2.url': AvatarMale03,
  'avatars:ProvveditoreEconomo-3.url': AvatarMale04,
  'avatars:ProvveditoreEconomo-4.url': AvatarMale05,
  'avatars:ProvveditoreEconomo-5.url': AvatarMale06,
  'avatars:ProvveditoreEconomo-6.url': AvatarFemale01,
  'avatars:ProvveditoreEconomo-7.url': AvatarFemale02,
  'avatars:ProvveditoreEconomo-8.url': AvatarFemale03,
  'avatars:ProvveditoreEconomo-9.url': AvatarFemale04,
  'avatars:ProvveditoreEconomo-10.url': AvatarFemale05,
  'avatars:ProvveditoreEconomo-11.url': AvatarFemale06,

  'avatars:ClinicoReferenteFederAsma-0.url': AvatarMale01,
  'avatars:ClinicoReferenteFederAsma-1.url': AvatarMale02,
  'avatars:ClinicoReferenteFederAsma-2.url': AvatarMale03,
  'avatars:ClinicoReferenteFederAsma-3.url': AvatarMale04,
  'avatars:ClinicoReferenteFederAsma-4.url': AvatarMale05,
  'avatars:ClinicoReferenteFederAsma-5.url': AvatarMale06,
  'avatars:ClinicoReferenteFederAsma-6.url': AvatarFemale01,
  'avatars:ClinicoReferenteFederAsma-7.url': AvatarFemale02,
  'avatars:ClinicoReferenteFederAsma-8.url': AvatarFemale03,
  'avatars:ClinicoReferenteFederAsma-9.url': AvatarFemale04,
  'avatars:ClinicoReferenteFederAsma-10.url': AvatarFemale05,
  'avatars:ClinicoReferenteFederAsma-11.url': AvatarFemale06,

  /** team-goals */
  'team-goals:ReduceTotalDrugsCosts.icon.url': 'goals/team/goal-1', // NOTE: Extension is added at runtime to support fallback formats for fucking Safari...
  'team-goals:ReduceTotalDrugsCosts.title':
    "Ridurre la spesa per farmaci dell'ospedale",
  'team-goals:ReduceUnexpectedEventsRelatedCosts.icon.url': 'goals/team/goal-2', // NOTE: Extension is added at runtime to support fallback formats for fucking Safari...
  'team-goals:ReduceUnexpectedEventsRelatedCosts.title':
    'Ridurre la spesa per la gestione degli eventi avversi',
  'team-goals:IncreaseTotalCompliance.icon.url': 'goals/team/goal-3', // NOTE: Extension is added at runtime to support fallback formats for fucking Safari...
  'team-goals:IncreaseTotalCompliance.title': 'Aumentare la compliance',

  /** personal-goals */
  'personal-goals:ReduceCostOfAsmaDrugs.icon.url': 'goals/personal/goal-1',
  'personal-goals:ReduceCostOfAsmaDrugs.title':
    'Contenimento della spesa farmaceutica per asma',
  'personal-goals:ReduceCostOfAsmaDrugs.notes': ' ',
  'personal-goals:KeepAGoodOrganizationClimate.icon.url':
    'goals/personal/goal-2',
  'personal-goals:KeepAGoodOrganizationClimate.title':
    'Creazione/mantenimento di un buon clima aziendale',
  'personal-goals:KeepAGoodOrganizationClimate.notes':
    '*Il raggiungimento di questo obiettivo sarà valutato come grado di soddisfazione espresso dagli altri partecipanti in merito alle scelte prese dal team.',
  'personal-goals:ReduceAdmissionsDueToUnexpectedEvents.icon.url':
    'goals/personal/goal-3',
  'personal-goals:ReduceAdmissionsDueToUnexpectedEvents.title':
    'Riduzione dei ricoveri per asma dovuti ad eventi avversi',
  'personal-goals:ReduceAdmissionsDueToUnexpectedEvents.notes': ' ',
  'personal-goals:ImproveWarehouseEfficacy.icon.url': 'goals/personal/goal-4',
  'personal-goals:ImproveWarehouseEfficacy.title':
    "Aumento dell'efficienza del magazzino",
  'personal-goals:ImproveWarehouseEfficacy.notes': ' ',
  'personal-goals:ImproveCompliance.icon.url': 'goals/personal/goal-5',
  'personal-goals:ImproveCompliance.title':
    "Incremento dell'aderenza terapeutica",
  'personal-goals:ImproveCompliance.notes': ' ',
  'personal-goals:ImproveTenderSpecificationWriting.icon.url':
    'goals/personal/goal-6',
  'personal-goals:ImproveTenderSpecificationWriting.title':
    'Miglioramento della stesura dei capitolati di gara',
  'personal-goals:ImproveTenderSpecificationWriting.notes': ' ',
  'personal-goals:ImprovePatientsWelfare.icon.url': 'goals/personal/goal-7',
  'personal-goals:ImprovePatientsWelfare.title':
    'Miglioramento della continuità assistenziale tra ospedale e territorio per i pazienti con asma grave',
  'personal-goals:ImprovePatientsWelfare.notes': ' ',
  'personal-goals:ImprovePeopleAwareness.icon.url': 'goals/personal/goal-8',
  'personal-goals:ImprovePeopleAwareness.title':
    "Incremento delle attività di sensibilizzazione della popolazione sui temi dell'asma grave",
  'personal-goals:ImprovePeopleAwareness.notes': ' ',
  'personal-goals:IncreaseNumberOfPediatricPatientsTreatedWithBio.icon.url':
    'goals/personal/goal-9',
  'personal-goals:IncreaseNumberOfPediatricPatientsTreatedWithBio.title':
    'Aumento del numero dei pazienti pediatrici affetti da asma grave trattati con farmaci biologici',
  'personal-goals:IncreaseNumberOfPediatricPatientsTreatedWithBio.notes': ' ',
  'personal-goals:IncreasePercentageOfPatientsTreatedWithBio.icon.url':
    'goals/personal/goal-10',
  'personal-goals:IncreasePercentageOfPatientsTreatedWithBio.title':
    'Aumento della % di pazienti affetti da asma grave trattati con farmaci biologici',
  'personal-goals:IncreasePercentageOfPatientsTreatedWithBio.notes': ' ',

  'goal.correct.icon.url': 'goals/positive.png',
  'goal.wrong.icon.url': 'goals/negative.png',

  /** variables */
  'vars:spesa-totale-farmaci.label': 'Spesa totale per farmaci',
  'vars:spesa-totale-oma.label': 'Di cui OMA',
  'vars:spesa-totale-mepo.label': 'Di cui MEPO',
  'vars:spesa-totale-eventi-avversi.label': 'Spesa totale per eventi avversi',
  'vars:compliance-media.label': 'Compliance media',
  'vars:treated-patients.label': 'Pazienti trattati',
  'vars:treated-patients-biological.label':
    '% pazienti trattati con farmaci biologici',

  'vars:budget-amount-result.note':
    '(*) La variazione è stata decisa dal team nella fase precedente.',

  /** chat */
  'chat:new-message.placeholder': 'Scrivi un messaggio...',
  'chat:new-message-disabled.placeholder': 'Chat disabilitata in questa fase.',

  /** teacher */
  'teacher:icons.sessions': TeacherSessionsIcon,
  'teacher:icons.session': TeacherSessionIcon,
  'teacher:icons.mission-control': TeacherMissionControlIcon,
  'teacher:icons.mission-control-white': TeacherMissionControlWhiteIcon,
  'teacher:icons.debrief': TeacherDebriefIcon,
  'teacher:icons.debrief-white': TeacherDebriefWhiteIcon,
  'teacher:icons.delete': TeacherDeleteIcon,
  'teacher:icons.copy-link': TeacherCopyLinkIcon,
  'teacher:icons.info': TeacherInfoIcon,
  'teacher:icons.stop': TeacherStopIcon,
  'teacher:icons.download': TeacherDownloadIcon,
  'teacher:icons.csv': TeacherCSVIcon,

  'teacher:sections.startup': 'Avvio',
  'teacher:sections.chat': 'Chat',
  'teacher:sections.live': 'Live',

  'teacher:sessions': 'Sessioni',
  'teacher:sessions.past-sessions': 'Sessioni concluse',
  'teacher:sessions.future-sessions': 'Sessioni future',
  'teacher:sessions.no-results': 'Nessun risultato',
  'teacher:sessions.loading': 'Caricamento...',

  'teacher:session.name': 'Nome della sessione',
  'teacher:session.name-short': 'Nome sessione',
  'teacher:session.date': 'Data della sessione',
  'teacher:session.date-short': 'Data',
  'teacher:session.actions': 'Azioni',
  'teacher:session.mission-control': 'Mission control',
  'teacher:session.mission-control.setup': 'Setup',
  'teacher:session.mission-control.live': 'Live',
  'teacher:session.debriefing': 'Debriefing',
  'teacher:session.delete': 'Elimina',
  'teacher:session.session-delete-prompt':
    "Confermi l'eliminazione della sessione {sessionID}?",
  'teacher:session.end-setup': 'Concludi setup',
  'teacher:session.team-name': 'Nome team',
  'teacher:session.team-add': 'Aggiungi',
  'teacher:session.team-remove-prompt':
    "Confermi l'eliminazione del team {teamName}?",
  'teacher:session.teams-reinit': 'Reinizializza team',
  'teacher:session.teams-reinit-prompt':
    'I team verranno reinizializzati e verranno perse tutte le personalizzazioni fatte finora, vuoi procedere?',
  'teacher:session.start': 'Avvia sessione',
  'teacher:session.chat.open': 'Apri chat',
  'teacher:session.chat.close': 'Chiudi chat',
  'teacher:session.url.copy': 'Copia link ruolo',
  'teacher:session.url.copy-all': 'Copia link team',
  'teacher:session.vote-satisfaction': 'Vota soddisfazione',
  'teacher:session.vote': 'Vota',

  'teacher:meeting.open-chat': 'Apri fase chat',
  'teacher:meeting.open-meeting': 'Apri meeting',
  'teacher:meeting.close-meeting': 'Chiudi meeting',

  'teacher:session.sections.setup': 'Setup',
  'teacher:session.sections.teams': 'Teams',
  'teacher:session.sections.bootstrap': 'Avvio',
  'teacher:session.sections.chat': 'Chat',

  'teacher.session.phases.init': 'Inizio',
  'teacher.session.phases.intro': 'Intro',
  'teacher.session.phases.phase-1': 'Fase 1',
  'teacher.session.phases.phase-2': 'Fase 2',
  'teacher.session.phases.phase-3': 'Fase 3',

  'teacher:session.play-as': 'Impersonifica',
  'teacher:session.previous-phase': 'Fase precedente',
  'teacher:session.next-phase': 'Fase successiva',

  'teacher:teaching-notes': 'Teaching notes',
  'teacher:help': 'Help',
  'teacher:sessions.search-button': 'Cerca',
  'teacher:sessions.search-placeholder': 'Cerca sessione',
  'teacher:session.create': 'Crea una nuova sessione',
  'teacher:sessions.create-button': 'Crea nuova sessione',
  'teacher:create': 'Crea',
  'teacher:cancel': 'Cancella',
  'teacher:icons.arrow-bottom': TeacherBottomArrowIcon,
  'teacher:icons.teaching-notes': TeacherTeachingNotesIcon,
  'teacher:icons.help': TeacherHelpIcon,

  'teacher.session.locations./home': 'Cover',
  'teacher.session.locations./rules': 'Spiegazione icone',
  'teacher.session.locations./waiting-rooms/intro': 'Waiting room',

  'teacher.session.locations./intro/mandate': 'Il tuo mandato',
  'teacher.session.locations./intro/team': 'Il tuo team',
  'teacher.session.locations./documents/RegioneVentosa': 'Tu sei il...',
  'teacher.session.locations./documents/UOCPneumologia':
    'Descrizione + i tuoi obiettivi',
  'teacher.session.locations./documents/IRCCS': 'Documento: IRCCS',
  'teacher.session.locations./documents/Organigramma':
    'Documento: Organigramma',
  'teacher.session.locations./avatar-selection': 'Selezione avatar',
  'teacher.session.locations./my-profile-presentation':
    'Lettura profilo giocatore',
  'teacher.session.locations./waiting-rooms/avatar': 'Waiting room avatar',
  'teacher.session.locations./my-team-members': 'Panoramica team',
  'teacher.session.locations./profiles': 'Lettura profili team',
  'teacher.session.locations./documents/AsmaGrave': 'Documento: Asma grave',
  'teacher.session.locations./documents/LetteraDG': 'Documento: Lettera DG',
  'teacher.session.locations./my-team-goals': 'Obiettivi',
  'teacher.session.locations./waiting-rooms/phase-1': 'Waiting room',

  'teacher.session.locations./documents': 'Archivio documenti',

  'teacher.session.locations.introductions/phase-1': 'Cover fase 1',
  'teacher.session.locations./documents/AnnoScorso': 'Documento: Anno scorso',
  'teacher.session.locations./scenarios/phase-1': 'Domanda',
  'teacher.session.locations./meetings/first-leg': 'Meeting',
  'teacher.session.locations./decisions/phase-1/vote': 'Votazione',
  'teacher.session.locations./waiting-rooms/votation-1': 'Waiting room',
  'teacher.session.locations./outcomes/phase-1': 'Recap votazione',
  'teacher.session.locations./satisfaction-surveys/phase-1':
    'Voto soddisfazione',
  'teacher.session.locations./waiting-rooms/satisfaction-1':
    'Waiting room soddisfazione',
  'teacher.session.locations./waiting-rooms/phase-2': 'Waiting room fase 2',

  'teacher.session.locations./introductions/phase-2': 'Cover fase 2',
  'teacher.session.locations./scenarios/phase-2': 'Domanda',
  'teacher.session.locations./meetings/second-leg': 'Meeting',
  'teacher.session.locations./decisions/phase-2/vote': 'Votazione',
  'teacher.session.locations./waiting-rooms/votation-2': 'Waiting room',
  'teacher.session.locations./outcomes/phase-2': 'Recap votazione',
  'teacher.session.locations./satisfaction-surveys/phase-2':
    'Voto soddisfazione',
  'teacher.session.locations./waiting-rooms/satisfaction-2':
    'Waiting room soddisfazione',
  'teacher.session.locations./waiting-rooms/phase-3': 'Waiting room fase 3',

  'teacher.session.locations./introductions/phase-3': 'Cover fase 3',
  'teacher.session.locations./breaking-news': 'Breaking news',
  'teacher.session.locations./documents/Articolo': 'Documento: Articolo',
  'teacher.session.locations./documents/Report': 'Documento: Report regionale',
  'teacher.session.locations./documents/LetteraDS': 'Documento: Lettera D.S.',
  'teacher.session.locations./scenarios/phase-3': 'Scenario fase 3',
  'teacher.session.locations./decisions/phase-3/description': 'Domanda',
  'teacher.session.locations./decisions/diagnosis/vote': 'Domanda 1',
  'teacher.session.locations./decisions/distribution/vote': 'Domanda 2',
  'teacher.session.locations./decisions/tender/vote': 'Domanda 3',
  'teacher.session.locations./waiting-rooms/ds-votation': 'Waiting room',
  'teacher.session.locations./outcomes/phase-3': 'Recap risposte',
  'teacher.session.locations./satisfaction-surveys/phase-3':
    'Voto soddisfazione',
  'teacher.session.locations./waiting-rooms/satisfaction-3':
    'Waiting room soddisfazione',

  'teacher.session.locations./feedback': 'Feedback',
  'teacher.session.locations./my-goals': 'Riepilogo obiettivi',
  'teacher.session.locations./outcomes': 'Risultato finale',
  'teacher.session.locations./thankyou': 'Ringraziamenti',

  'teacher.debriefing.stop':
    'Completa la sessione in corso per poter accedere al debriefing.',

  'teacher.debriefing.teams-goals-debrief.reached-goals': 'Obiettivi raggiunti',
  'teacher.debriefing.teams.all': 'Tutti',
  'teacher.debriefing.teams.none': 'Nessuno',
  'teacher.debriefing.phase-2-vote-debrief.phase-1-decision':
    'Scelta del team in fase 1',

  'teacher.csv.message':
    'Clicca il tasto sottostante per scaricare un report CSV di tutte le sessioni di Hospitalia',
  'teacher.csv.download': 'Scarica CSV',

  'teacher.session.phases.Init': 'Avvio',
  'teacher.session.phases.Intro': 'Introduzione',
  'teacher.session.phases.Phase 1': 'Fase 1 - Definizione delle risorse',
  'teacher.session.phases.Phase 2':
    'Fase 2 - Allocazione delle risorse e scelte terapeutiche',
  'teacher.session.phases.Phase 3': 'Fase 3 - Gestione evento straordinario',
  'teacher.session.phases.Endgame': 'Conclusione',

  'pages:decisions-phase-1.title':
    'Di quanto faresti variare le risorse a disposizione dell’asma grave per il prossimo anno?',
};
